
import SockJS from 'sockjs-client';
import Stomp from 'stompjs';
import { v4 as uuidv4 } from 'uuid';

export default class SocketUtil {
    options = {
        giveup:10,
        timeOut:60,
        sendUrl: '/app/operation',
        before:()=> {},
        complete:()=> {},
        failback:()=> {},
    }

    uuid = ''

    socket = {}

    stompClient = {}

    status = false

    reConnNumber = 0

    constructor(url, option){
        this.setOption(url, option);
        this.connect();
        this.uuid = uuidv4();
    }

    setOption = (url, option) =>{
        this.options = {
            url,
            ...this.options,
            ...option,
        }
    }

    connect = () => {
        const { url } = this.options;
        if (url){
            this.socket = new SockJS(url);
            this.stompClient = Stomp.over(this.socket);
            this.options.before();
            this.watch();
        }
    }

    watch = () => {
        const self = this;
        this.stompClient.connect({},
            frame => {
                self.status = true;
                this.clearTime();
                this.options.complete(frame);
            },
            () => {
                console.log(`断线了!!!!`);
                self.status = false;
                self.reConnection();
            }
        );
    
    }
    
    subscribe = (url, callback) => {
        this.stompClient.subscribe(url, data => {
            if (callback) callback(data)
        });
    }

    send = (method, data) => {
        const so = this.sendObj(method, data);
        return new Promise((resolve) => {
            let timer = null;
            const subscription = this.stompClient.subscribe(`/topic/response/${this.uuid}`, result => {
                if (result && result.body && JSON.parse(result.body).id === so.id) {
                    const obj = result.body;
                    resolve(JSON.parse(obj));
                    clearInterval(timer);
                    subscription.unsubscribe();                   
                }
            });
            timer = setTimeout(() => {
                subscription.unsubscribe();
                console.log(`【${method}】【${subscription.id}】请求超时,关闭subscribe`);
                resolve(null);
            }, this.options.timeOut * 1000);

            this.stompClient.send(this.options.sendUrl, {}, JSON.stringify(so));
        });
    }


    sendObj = (method, params) => {
        return {jsonrpc: "2.0", method, params:{...params, userId:this.uuid}, id: uuidv4()}
    }

    reConnection = () => {
        if (this.reConnNumber >= this.options.giveup ) {
            this.clearTime();
            this.options.failback()
            return ;
        }
        if (window.location.href.indexOf('excellence') === -1 || window.location.href.indexOf('interact') === -1) {
            this.clearTime();
            return ;
        }

        this.setTimer();
    }

    setTimer = () => {
        const self = this;
        this.timeIndex = setTimeout(() => {
            self.reConnNumber += 1;
            console.error(`重连中, 重连${self.reConnNumber}次...`);
            self.connect();
        }, 5000);
    }

    clearTime = () => {
        clearTimeout(this.timeIndex);
        this.reConnNumber = 0;
    }

    getOption = () => {
        return this.options;
    }

}
